// Generated at build time by scripts/generate-version.js — do not edit.
export const version = {
  sha: 'c16ac60ceec9fc5bb0034851643262af4cca7d54',
  shortSha: 'c16ac60',
  builtAt: '2026-11-03T15:03:48.085Z',
};
